export const assetsUrl = import.meta.env.VITE_HOST;
